module.exports = __webpack_public_path__ + "static/media/friendship_red.7f226f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/friendship_red.png
// module id = 850
// module chunks = 0